export default __webpack_public_path__ + "static/81861-e3b11264c13cd1f574b483aa9b298fa1.jpg";